import { useState } from 'react';
import { Box, Typography } from '@mui/material';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { CustomerFiles } from '@prisma/client';
import { openStorageUrl } from '../../../../helpers/global';
import { SURFACE_HOVER } from '../colors';
import { describeFileCard } from './fileCardContent';

interface Props {
  file: CustomerFiles;
  timezone: string;
  displayUrl: string;
  onImageError: () => void;
  onOpenImage: () => void;
}

function FileCard({
  file,
  timezone,
  displayUrl,
  onImageError,
  onOpenImage,
}: Props) {
  const content = describeFileCard(file, timezone);
  const [imageFailed, setImageFailed] = useState(false);
  const showImage = content.preview.kind === 'image' && !imageFailed;

  return (
    <Box
      component="button"
      type="button"
      // Unrenderable images (e.g. HEIC) open directly, like PDFs.
      onClick={() => (showImage ? onOpenImage() : openStorageUrl(content.url))}
      sx={{
        display: 'block',
        width: '100%',
        minWidth: 0,
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        textAlign: 'left',
        font: 'inherit',
      }}>
      {showImage ? (
        <Box
          component="img"
          src={displayUrl}
          alt={content.name}
          loading="lazy"
          onError={() => {
            setImageFailed(true);
            onImageError();
          }}
          sx={{
            width: '100%',
            height: '150px',
            objectFit: 'cover',
            border: '1px solid',
            borderColor: 'common.black',
            borderRadius: '10px',
          }}
        />
      ) : (
        <Box
          sx={{
            width: '100%',
            height: '150px',
            border: '1px solid',
            borderColor: 'common.black',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: SURFACE_HOVER,
          }}>
          <InsertDriveFileIcon
            sx={{ fontSize: '28px', color: 'text.tertiary' }}
          />
        </Box>
      )}
      <Typography
        variant="h5"
        sx={{
          color: 'text.primary',
          marginTop: '10px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}>
        {content.name}
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: 'text.tertiary', marginTop: '3px' }}>
        {content.subline}
      </Typography>
    </Box>
  );
}

export default FileCard;
